module.exports = __webpack_public_path__ + "static/media/sedan.0a2907a6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/CarType/images/sedan.jpg
// module id = 528
// module chunks = 0